import React from 'react';
import { Clock } from 'lucide-react';

interface NoContactFilterProps {
  selectedDays: number | null;
  onSelect: (days: number | null) => void;
  className?: string;
}

export default function NoContactFilter({ selectedDays, onSelect, className }: NoContactFilterProps) {
  const options = [7, 14, 30, 60, 90, 'ever'];

  return (
    <div className={`flex flex-col gap-1 w-full md:w-fit ${className || ''}`}>
      <label className="text-sm text-gray-400">No Contact In</label>
      <div className="flex flex-wrap bg-dark-800 rounded-lg p-1 gap-1 w-full md:w-fit">
        {options.map(option => (
          <button
            key={option}
            onClick={() => onSelect(selectedDays === (option === 'ever' ? -1 : Number(option)) ? null : (option === 'ever' ? -1 : Number(option)))}
            className={`flex-1 md:flex-initial px-3 py-1 rounded-md text-sm flex items-center justify-center gap-2 transition-colors ${
              selectedDays === (option === 'ever' ? -1 : Number(option))
                ? 'bg-primary-600 text-white' 
                : 'text-gray-400 hover:text-white hover:bg-dark-700'
            }`}
          >
            <Clock className="w-4 h-4" />
            {option === 'ever' ? 'Ever' : `${option}d`}
          </button>
        ))}
      </div>
    </div>
  );
}